import React from 'react'
import { NavLink } from 'react-router-dom'
import logo from '../images/LOGO-transparent.png'

const Footer = () => {
    return (
        <footer className="container-fluid footer p-5 footer-back " >
            <div className="container">
                <div className="row">
                    <div className="col-10 col-sm-4 col-lg-4 text-white">
                        <img src={logo} alt="careergrads" className="m-1 careergrads" style={{ width: '16rem' }} />
                        <h5>
                            <i class="fa fa-location-arrow" aria-hidden="true"></i>
                            <strong> New Delhi 110042</strong> </h5>

                    </div>
                    <div className="col-10 col-sm-4 col-lg-4 mt-3">
                        <div className=" ml-1 ">
                            <div className="d-flex flex-column align-content-center text-white">
                                <h4><strong>Company </strong> </h4>
                                <NavLink exact to='/about' className="text-decoration-none text-white-50 my-1">
                                    About Us
                                </NavLink>
                                <NavLink exact to='/about' className="text-decoration-none text-white-50 my-1">
                                    Blogs
                                </NavLink>
                                <NavLink exact to='/about' className="text-decoration-none text-white-50 my-1">
                                    Privacy Policy
                                </NavLink>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1">
                                    Terms & Conditions
                                </NavLink>
                                <NavLink exact to='/contact' className="text-decoration-none text-white-50 my-1">
                                    Contact Us
                                </NavLink>

                            </div>
                        </div>

                    </div>
                    <div className="col-10 col-sm-4 col-lg-4">
                        <div className="text-white mt-2">
                            <div className="d-flex flex-column align-content-center">
                                <h4><strong>Quick Links</strong></h4>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1">
                                    Online Courses
                                </NavLink>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1">
                                    Pratical Approach
                                </NavLink>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1">
                                    Tutorials
                                </NavLink>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1">
                                    CampusGrads
                                </NavLink>
                                <NavLink exact to='/project' className="text-decoration-none text-white-50 my-1">
                                    Projects
                                </NavLink>
                                <NavLink exact to='/services' className="text-decoration-none text-white-50 my-1 ">
                                    Competition & More...
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*Nav Links of Footer*/}
            <div className="container-fluid" >
                <div className="container m-0 p-0">
                    <p className="text-white text-center mt-2">Connect With Us</p>
                    <div className="d-flex justify-content-center mt-3">
                        <ul className="nav f_links">
                            <li className="nav-link nav-item"><a target="blank" href='https://www.facebook.com/Careergrads-113726223804184/'><i class="fa fa-facebook " aria-hidden="true"></i
                            ></a></li>
                            <li className="nav-link nav-item"><a target="blank" href='https://www.instagram.com/careergrads/'><i class=" fa fa-instagram" aria-hidden="true"></i
                            ></a></li>
                            <li className="nav-link nav-item"><a target="blank" href='https://www.linkedin.com/company/careergrads/mycompany/'>
                                <i class=" fa fa-linkedin" aria-hidden="true"></i
                                ></a></li>
                            <li className="nav-link nav-item"><a target="blank" href='/'><i class=" fa fa-twitter" aria-hidden="true"></i
                            ></a></li>
                            <li className="nav-link nav-item"><a target="blank" href='mailto:info@careergrads.com'><i class=" fa fa-envelope"></i></a></li>
                        </ul>
                    </div>
                </div>
                <hr />
                <div className="text-center text-white-50 mt-3 ">
                    <p>All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i><a href="/" className="text-decoration-none"> CareerGrads.com</a></p>
                </div>
            </div>

        </footer>

    )
}

export default Footer
